import styled from '@emotion/styled';
import { css } from '@emotion/core';
import {
  BREAKPOINTS,
  COLOR as COLOR_LEGACY,
  FONT_WEIGHT,
  FONT_SIZE,
} from '@ordermentum/ui-constants';

const colSizePartial = (props: any) => {
  if (props.width === 'half') {
    return css`
      width: 50%;
      &:first-child {
        margin-right: 1.0625rem;
      }

      &:last-child {
        margin-left: 1.0625rem;
      }
    `;
  }
  return css``;
};

export const PaymentMethodRow = styled('div')`
  display: flex;
  width: 100%;
  position: relative;
  padding-bottom: 1.25rem;
  flex-direction: row;
  align-items: flex-start;
`;

export const PaymentMethodColumn = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ${colSizePartial};
`;

export const PaymentMethodError = styled('p')`
  color: ${COLOR_LEGACY.RED_500};
  font-weight: ${FONT_WEIGHT.BOLD};
  font-size: ${FONT_SIZE.SM};
  margin: 0;
  padding-top: 0.5rem;
`;

export const PaymentMethodFieldWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const PaymentMethodCardImage = styled('img')`
  height: 1.875rem;
  width: 1.875rem;

  position: absolute;
  top: 2.4rem;
  right: 0.5rem;
`;

export const DefaultPayment = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${COLOR_LEGACY.GRAY_400};
  font-size: 0.875rem;
  font-weight: ${FONT_WEIGHT.MEDIUM};
`;

export const ButtonWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem 0 2.5rem 0;

  & > :last-child {
    margin-left: 1rem;
  }

  @media screen and (max-width: ${BREAKPOINTS.MOBILE_MAX}) {
    padding: 1rem 0 2.5rem 0;
  }
`;
